export default __webpack_public_path__ + "static/media/YouTube.940dbdb5.svg";